import { createFileRoute, redirect } from '@tanstack/react-router';
import { ConnectReturnPage } from '@/containers/sequences/sender-connections/connect-return.component';

// Sender connections live under Sequencing settings. Keep this path working
// for existing links, sidebar entries, and bookmarks by redirecting there.
//
// The hosted connect flow also returns here, with `?connected=1` or `?error=1`.
// Both are carried over, so Sender connections can confirm the result instead
// of a connect (or a failed one) ending in silence.
//
// The connect dialog opens the sign-in in a window and asks for `popup=1`:
// that window stays here, tells the dialog how it ended and closes itself.
export const Route = createFileRoute('/settings/email-accounts')({
  validateSearch: (search: Record<string, unknown>) => ({
    connected: search.connected !== undefined ? ('1' as const) : undefined,
    error: search.error !== undefined ? ('1' as const) : undefined,
    popup: search.popup !== undefined ? ('1' as const) : undefined,
    attempt_id:
      typeof search.attempt_id === 'string' ? search.attempt_id : undefined,
  }),
  beforeLoad: ({ search }) => {
    if (search.popup) return;
    throw redirect({
      to: '/sequencing/settings',
      search: {
        section: 'senders',
        connected: search.connected,
        connect_failed: search.error,
      },
    });
  },
  component: ConnectReturnRoute,
});

function ConnectReturnRoute() {
  const { error, attempt_id } = Route.useSearch();
  return <ConnectReturnPage ok={!error} attemptId={attempt_id} />;
}
